<app-message *ngIf="isMyOrg" [ctx]="messageCtx" class="message"></app-message>
<div class="tab-body-top">
  <h3>Posts</h3>
</div>
<app-organization-posts [orgId]="orgId" [posts]="posts"></app-organization-posts>
